import styled, { css } from 'styled-components';

import { ResourcesNoData } from './ResourcesNoData';

const TabsResourcesNoData = styled(ResourcesNoData)<{ first?: boolean }>`
  margin-top: 0;

  ${({ first }) =>
    first &&
    css`
      border-top-left-radius: 0;
    `}
`;

export { TabsResourcesNoData };
